export default __webpack_public_path__ + "static/media/goldentick.af876fa5.svg";